export const casper_permission= {
    required_permission:["add_caspermessage", "change_caspermessage", "delete_caspermessage", "view_caspermessage"],
}